import DOMPurify from 'dompurify';
import { API_BASE_URL } from '../config';

// Zengin metin editöründen gelen HTML'i dangerouslySetInnerHTML'e vermeden
// önce bu fonksiyondan geçirin. Script, iframe, event handler ve javascript:
// URL'leri temizlenir.
const ALLOWED_TAGS = [
  'p', 'br', 'hr', 'div', 'span',
  'strong', 'b', 'em', 'i', 'u', 's', 'sub', 'sup', 'mark', 'small',
  'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
  'ul', 'ol', 'li',
  'blockquote', 'pre', 'code',
  'a', 'img',
  'table', 'thead', 'tbody', 'tfoot', 'tr', 'th', 'td',
];

const ALLOWED_ATTR = [
  'href', 'target', 'rel', 'title',
  'src', 'alt', 'width', 'height',
  'class', 'style',
  'colspan', 'rowspan',
];

export function sanitizeHtml(dirty) {
  if (dirty == null) return '';
  return DOMPurify.sanitize(String(dirty), {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
    ALLOW_DATA_ATTR: false,
    FORBID_TAGS: ['script', 'style', 'iframe', 'object', 'embed', 'form'],
    FORBID_ATTR: ['onerror', 'onload', 'onclick', 'onmouseover', 'onfocus', 'onblur'],
  });
}

export function toAbsoluteUploadUrl(url) {
  if (!url || typeof url !== 'string') return url;
  if (url.startsWith('/uploads/')) return `${API_BASE_URL}${url}`;
  return url;
}

// DB'de relative olarak saklanan "/uploads/..." URL'lerini backend mutlak
// URL'ine cevirir (farkli portlardaki frontend/backend icin). Env degisirse
// kayitli URL'ler bozulmaz.
export function rewriteUploadUrls(html) {
  if (!html) return html;
  try {
    return String(html)
      .replace(/(src|href)=(["'])\/uploads\//g, `$1=$2${API_BASE_URL}/uploads/`);
  } catch (e) {
    return html;
  }
}

// rewriteUploadUrls'in tersi: kayit oncesi mutlak URL'leri relative'e cevirir
// ki DB portable kalsin (env degisirse).
export function relativizeUploadUrls(html) {
  if (!html) return html;
  try {
    const base = String(API_BASE_URL || '').replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const re = new RegExp(`(src|href)=(["'])${base}/uploads/`, 'g');
    return String(html).replace(re, '$1=$2/uploads/');
  } catch (e) {
    return html;
  }
}

export function sanitizedHtmlProps(dirty) {
  return { __html: sanitizeHtml(rewriteUploadUrls(dirty)) };
}
